<template>
    <div class="section-container container-fixed">

        <!--
        <div class="row justify-content-center">
            <div class="col-10">
                <section class="content-block">
                    <header class="header">{{ 'ABOUT_HEADER' | translate }}</header>
                    <p v-html="$t('ABOUT')"></p>
                </section>
                <section class="content-block">
                    <header class="header">{{ 'TOKENS_HEADER' | translate }}</header>
                    <p v-html="$t('TOKENS')"></p>
                </section>
                <section class="content-block">
                    <header class="header">{{ 'GEN_0_HEADER' | translate }}</header>
                    <p v-html="$t('GEN_0')"></p>
                    <div class="row text-center">
                        <div v-for="(card, index) in GEN_0_CARDS" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                            <div class="content-container">
                                <div class="content-display">
                                     <img :src="'/static/card_' + card + '.png'" alt="card image" width="80%">
                                </div>
                                <div class="content-label">
                                    {{ card.split('_').join(' ') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="content-block">
                    <header class="header">{{ 'GEN_X_HEADER' | translate }}</header>
                    <p v-html="$t('GEN_X')"></p>
                    <div class="row text-center">
                        <div v-for="(card, index) in GEN_X_CARDS" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                            <div class="content-container">
                                <div class="content-display">
                                     <img :src="'/static/card_' + card + '.png'" alt="card image" width="80%">
                                </div>
                                <div class="content-label">
                                    {{ card.split('_').join(' ') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="content-block">
                    <header class="header">{{ 'FEES_HEADER' | translate }}</header>
                    <p v-html="$t('FEES_1')"></p>
                    <p v-html="$t('FEES_2')"></p>
                    <sub v-html="$t('SUBJECT_TO_CHANGE')"></sub>
                </section>
            </div>
        </div>
        -->
        
    </div>
</template>

<script>
import { GEN_0_CARDS, GEN_X_CARDS } from "../util/constants/cards";

export default {
    name: 'About',
    computed: {
        GEN_0_CARDS () {
            return GEN_0_CARDS;
        },
        GEN_X_CARDS () {
            return GEN_X_CARDS;
        }
    }
}
</script>

<style scoped lang="less">
@import "../assets/less/generic.less";

.section-container {
    .content-container {
        margin-bottom: 20px;
        border: 1px solid #ccc;
        background: #3c3f44;

        .content-display {
            padding: 40px 20px;
        }

        .content-label {
            text-align: center;
            text-transform: capitalize;
            background: #F8F8F8;
            margin-top: 30px;
            padding: 20px;
            margin: 5px;
            white-space: nowrap;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/About.vue